import React from 'react'

const CheckboxInput = React.forwardRef((props, ref) => (
  <label className='filter-checkbox-label'>
    <input type='checkbox' {...props} ref={ref} />
  </label>
))

export default CheckboxInput
